function toNumberOnly(value) {
    if (value) {
      return value.replace(/\D/g, '')
    } else {
      return ''
    }
  }
  
  export { toNumberOnly }